<template>
  <div class="card mb-4">
    <loader v-if="loader.table" style="z-index:10000" object="#344767" color1="#ffffff" color2="#2152ff" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="circular"></loader>
    <div class="card-header pb-0">
      <div class="row">
        <div class="col-md-8 d-flex align-items-center">
            <h6>List of Applicants</h6>
        </div>
        <div class="col-md-4 text-end">
            <router-link :to="{ name: 'Pensioners' }">
              Upload <i class="fas fa-plus-circle text-secondary text-lg" data-bs-toggle="tooltip" data-bs-placement="top" title="" aria-hidden="true" data-bs-original-title="Add User" aria-label="Add Group"></i><span class="sr-only">Add Beneficiary</span>
            </router-link>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-data-holder" v-if="loader.table==false && message==''">
        <div class="table-responsive p-0">
          <div class="filter-records-holder">
            <div class="row">
              <div class="col-md-12">
                <div class="px-4 py-4 text-xs">
                  <b>Total Records :</b> {{rows}}, <b>Per Page :</b> {{perPage}}
                </div>
              </div>
              <div class="col-md-12">
                <div class="py-3 text-xs">
                  <form @submit.prevent="SubmitSearchForm" class="px-4 pb-3">
                    <!-- Row 1: Primary Search Fields -->
                    <div class="row mb-3"> 
                      <div class="col-md-3">
                        <label class="form-label text-xs  mb-1">Name</label>
                        <input type="text" name="nameInput" v-model="searchByname" class="form-control form-control-sm" placeholder="Search by name" >
                      </div>
                      <div class="col-md-2">
                        <label class="form-label text-xs  mb-1">GSM/Phone</label>
                        <input type="text" name="phoneInput" v-model="searchByphone" class="form-control form-control-sm" placeholder="08012345678" >
                      </div>
                      <div class="col-md-2">
                        <label class="form-label text-xs  mb-1">BVN</label>
                        <input type="text" name="bvnInput" v-model="searchBybvn" class="form-control form-control-sm" placeholder="Enter BVN" maxlength="11">
                      </div>
                      <div class="col-md-2">
                        <label class="form-label text-xs  mb-1">NIN</label>
                        <input type="text" name="ninInput" v-model="searchBynin" class="form-control form-control-sm" placeholder="Enter NIN" maxlength="11">
                      </div>
                      <div class="col-md-3">
                        <label class="form-label text-xs  mb-1">Account Number</label>
                        <input type="text" name="accountInput" v-model="searchByaccount" class="form-control form-control-sm" placeholder="Account No." maxlength="10">
                      </div>
                    </div>
                    <!-- Row 2: Secondary Filters -->
                    <div class="row mb-3">
                      <div class="col-md-2">
                        <label class="form-label text-xs  mb-1">Pension ID</label>
                        <input type="text" name="pensionIdInput" v-model="searchBypensionId" class="form-control form-control-sm" placeholder="KT-PEN-XX-XXXX">
                      </div>
                      <div class="col-md-2">
                        <label class="form-label text-xs  mb-1">Status</label>
                        <select name="status" class="form-control form-control-sm" v-model="searchBystatus">
                          <option value="">All Status</option>
                          <option value="completed">Verified</option>
                          <option value="pending">Not-verified</option>
                        </select>
                      </div>
                      <div class="col-md-2">
                        <label class="form-label text-xs  mb-1">Sub-Status</label>
                        <select name="subStatus" class="form-control form-control-sm" v-model="searchBysubStatus" :disabled="searchBystatus !== 'pending'">
                          <option value="">All</option>
                          <option value="incomplete">Incomplete</option>
                          <option value="discrepancy">Discrepancy</option>
                          <option value="suspicious">Suspicious</option>
                          <option value="not_on_payroll">Not on Payroll</option>
                        </select>
                      </div>
                      <div class="col-md-2">
                        <label class="form-label text-xs  mb-1">Pensioner Type</label>
                        <select name="type" class="form-control form-control-sm" v-model="searchBytype">
                          <option value="">All Types</option>
                          <option value="0">State Pensioner</option>
                          <option value="1">LGA Pensioner</option>
                        </select>
                      </div>
                      <div class="col-md-4">
                        <label class="form-label text-xs  mb-1">&nbsp;</label>
                        <div class="d-flex gap-2">
                          <VsudButton class="flex-grow-1" color="info" variant="gradient" size="sm">
                            <i class="fas fa-search me-1"></i> Search
                          </VsudButton>
                          <span class="btn mb-0 bg-gradient-secondary btn-sm" @click="SearchReset">
                            <i class="fas fa-redo me-1"></i> Reset
                          </span>
                          <span class="btn mb-0 bg-gradient-dark btn-sm" @click="toggleAdvancedFilters">
                            <i :class="showAdvancedFilters ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- Row 3: Advanced Filters (Collapsible) -->
                    <div class="row" v-show="showAdvancedFilters">
                      <div class="col-12">
                        <div class="bg-gray-100 rounded py-3">
                          <div class="row">
                            <div class="col-md-3">
                              <label class="form-label text-xs  mb-1">Bank Name</label>
                              <select name="bank" class="form-control form-control-sm" v-model="searchBybank">
                                <option value="">All Banks</option>
                                <option v-for="bank in banksList" :key="bank.id" :value="bank.name">{{ bank.name }}</option>
                              </select>
                            </div>
                            <div class="col-md-2">
                              <label class="form-label text-xs  mb-1">Min Pension (₦)</label>
                              <input type="number" v-model="searchByminPension" class="form-control form-control-sm" placeholder="0">
                            </div>
                            <div class="col-md-2">
                              <label class="form-label text-xs  mb-1">Max Pension (₦)</label>
                              <input type="number" v-model="searchBymaxPension" class="form-control form-control-sm" placeholder="0">
                            </div>
                            <div class="col-md-2">
                              <label class="form-label text-xs  mb-1">LGA</label>
                              <select name="lga" class="form-control form-control-sm" v-model="searchBylga">
                                <option value="">All LGAs</option>
                                <option v-for="lga in lgasList" :key="lga.id" :value="lga.name">{{ lga.name }}</option>
                              </select>
                            </div>
                            <div class="col-md-3">
                              <label class="form-label text-xs  mb-1">
                                <input type="checkbox" v-model="searchBydualPensioner" class="me-1"> 
                                Dual Pensioners Only
                              </label>
                              <p class="text-xs text-muted mb-0">Pensioners with both LGA and State pensions</p>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-md-3">
                              <label class="form-label text-xs  mb-1">Grade Level</label>
                              <input type="text" name="gradeLevelInput" v-model="searchBygradeLevel" class="form-control form-control-sm" placeholder="e.g. GL 14">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Pension ID
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  GPS
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Firstname
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Lastname
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Phone No.
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  NIN
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  BVN
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Account No.
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Bank
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Lga
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 sortable-th"
                  @click="toggleSort('monthly_pension')"
                  title="Click to sort by pension (asc/desc) - top row is the lowest/highest pension">
                  Monthly Pension
                  <i class="fas ms-1" :class="sortIconClass('monthly_pension')"></i>
                </th>  
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Type
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Status
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Sub-Status
                </th>                
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Updated At
                </th>
                <th class="text-secondary opacity-7">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in TableData" :key="data.id">
                <!-- Pension ID -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs font-weight-bold text-info" v-if="getPensionId(data)">
                      {{ getPensionId(data) }}
                    </span>
                    <span class="text-xs text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- GPS -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span v-if="data.locationCoordinates !== null">
                      <span v-if="checkGpsExist(data.locationCoordinates).status == true" class="text-success">
                        <i class="fas fa-map" v-if="checkGpsExist(data.locationCoordinates).is_polygon == true"></i>
                        <i class="fas fa-map-marker-alt" v-else></i>
                      </span>
                      <span v-else class="text-muted">—</span>
                    </span>
                    <span v-else class="text-muted">—</span>
                  </div>
                </td>
                <!-- Firstname -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs font-weight-bold" v-if="data.firstName">
                      {{ data.firstName }}
                    </span>
                    <span class="text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- Lastname -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs font-weight-bold" v-if="data.lastName">
                      {{ data.lastName }}
                    </span>
                    <span class="text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- Phone No. -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs" v-if="data.phoneNo">{{ data.phoneNo }}</span>
                    <span class="text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- NIN -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs" v-if="data.nin">{{ data.nin }}</span>
                    <span class="text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- BVN -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs" v-if="data.bvn">{{ data.bvn }}</span>
                    <span class="text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- Account No. -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs" v-if="data.accountNumber">{{ data.accountNumber }}</span>
                    <span class="text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- Bank -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs" v-if="data.bankName" :title="data.bankName">
                      {{ truncateText(data.bankName, 15) }}
                    </span>
                    <span class="text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- LGA -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs" v-if="data.lga">{{ data.lga }}</span>
                    <span class="text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- Monthly Pension -->
                <td>
                  <div class="d-flex px-2 py-1">
                    <span class="text-xs font-weight-bold text-dark" v-if="data.monthlyPension !== null && data.monthlyPension !== undefined">
                      ₦{{ data.monthlyPension.toLocaleString("en-us") }}
                    </span>
                    <span class="text-muted" v-else>—</span>
                  </div>
                </td>
                <!-- Type (State/LGA) -->
                <td class="align-middle text-center text-sm">
                  <vsud-badge v-if="data.isLga == 1" color="info" variant="gradient" size="sm">LGA</vsud-badge>
                  <vsud-badge v-else color="warning" variant="gradient" size="sm">State</vsud-badge>
                </td>
                <!-- Status -->
                <td class="align-middle text-center text-sm">
                  <vsud-badge v-if="data.status == 'completed'" color="success" variant="gradient" size="sm">Verified</vsud-badge>
                  <vsud-badge v-else color="danger" variant="gradient" size="sm">Not Verified</vsud-badge>
                </td>
                <!-- Sub-Status -->
                <td class="align-middle text-center text-sm">
                  <span v-if="data.status !== 'completed'">
                    <vsud-badge :color="getSubStatusColor(data.subStatus)" variant="gradient" size="sm">
                      {{ formatSubStatus(data.subStatus) }}
                    </vsud-badge>
                  </span>
                  <span v-else class="text-muted text-xs">—</span>
                </td>
                <!-- Updated At -->
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold" v-if="data.updatedAt !== null">
                    {{ moment(data.updatedAt).format("MMM DD, YYYY") }}
                  </span>
                  <span class="text-secondary text-xs" v-else>—</span>
                </td>
                <!-- Actions -->
                <td class="align-middle">
                  <div class="d-flex gap-2">
                    <router-link
                      class="btn btn-link text-info px-2 mb-0"
                      data-toggle="tooltip"
                      title="View Summary"
                      :to="{ name: 'View Pensioner', params: { id: data.id }, query: { view: 'summary' } }">
                      <i class="fas fa-file-alt text-sm"></i>
                    </router-link>
                    <router-link
                      class="btn btn-link text-dark px-2 mb-0"
                      data-toggle="tooltip"
                      title="View Details"
                      target="_blank"
                      :to="{ name: 'View Pensioner', params: { id: data.id }, query: { view: 'details' } }">
                      <i class="fas fa-eye text-sm"></i>
                    </router-link>
                    <button
                      class="btn btn-link text-danger px-2 mb-0"
                      data-toggle="tooltip"
                      title="Archive Pensioner"
                      @click="openArchiveModal(data)">
                      <i class="fas fa-archive text-sm"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="p-3">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @click="handlePageChange(currentPage)" aria-controls="my-table"></b-pagination>
          </div>
        </div>
      </div>
      <div class="spiner-holder text-center" v-else-if="loader.table==true && message==''">
        <!-- <vsud-spinner></vsud-spinner> -->
        <p class="py-5">
          Loading ...
        </p>
      </div>
      <div class="nodata-holder" v-else>
        <vsud-nodata :message="message"></vsud-nodata>
        <p class="text-center mb-5">
          <span class="btn mb-0 bg-gradient-success btn-md null null pull-right" @click="reloadPage">Reload</span>
        </p>
      </div>
    </div>
  </div>

  <!-- Archive Confirmation Modal - Teleported to body -->
  <Teleport to="body">
    <div class="modal fade" :class="{ 'show d-block': showArchiveModal }" tabindex="-1" v-if="showArchiveModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-secondary">
            <h5 class="modal-title text-white">
              <i class="fas fa-archive me-2"></i>Archive Pensioner
            </h5>
            <button type="button" class="btn-close btn-close-white" @click="closeArchiveModal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning mb-3">
              <i class="fas fa-exclamation-triangle me-2"></i>
              <strong>Warning:</strong> This action will archive/remove this pensioner record. This may not be reversible.
            </div>
            
            <div class="text-center mb-3" v-if="selectedPensioner">
              <p class="mb-1">You are about to archive:</p>
              <h6 class="text-dark">{{ selectedPensioner.firstName }} {{ selectedPensioner.lastName }}</h6>
              <p class="text-muted text-sm mb-0">
                <span v-if="getPensionId(selectedPensioner)">ID: {{ getPensionId(selectedPensioner) }}</span>
                <span v-if="selectedPensioner.bvn"> | BVN: {{ selectedPensioner.bvn }}</span>
              </p>
            </div>

            <div v-if="archiveError" class="alert alert-danger mb-0">
              <i class="fas fa-times-circle me-2"></i>{{ archiveError }}
            </div>

            <div v-if="archiveSuccess" class="alert alert-success mb-0">
              <i class="fas fa-check-circle me-2"></i>Pensioner archived successfully!
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeArchiveModal" :disabled="isArchiving">
              Cancel
            </button>
            <button 
              type="button" 
              class="btn btn-danger" 
              @click="archivePensioner" 
              :disabled="isArchiving || archiveSuccess"
            >
              <span v-if="isArchiving">
                <i class="fas fa-spinner fa-spin me-1"></i> Archiving...
              </span>
              <span v-else>
                <i class="fas fa-archive me-1"></i> Archive Pensioner
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-if="showArchiveModal" @click="closeArchiveModal"></div>
  </Teleport>
</template>
<script>
import VsudSpinner from "@/components/VsudSpinner.vue";
import VsudButton from "@/components/VsudButton.vue";
import VsudNodata from "@/components/VsudNodata.vue";
import AuthService from '@/services/auth.service.js';
import VsudBadge from "@/components/VsudBadge.vue";
import VsudSpinnerSmall from "@/components/VsudSpinnerSmall.vue";
import moment from "moment";
import Helper from '@/services/auth.helpers.js';

export default {
  name: "beneficiary-table",
  data()
  {
    return {
      /**
       * Old data binds
       * 
       * @description : N/A 
       */
      isLoading : false,
      isSearchLoading : false,
      states : [],
      isStateLoading : false,
      /**
       * New Data Bind
       * 
       * @description 
       */
      TableData : [],
      loader : {
        table : false,
        search : false
      },
      // Search Filters
      searchBystatus : '',
      searchBysubStatus : '',
      searchBytype : '',
      searchByphone : '',
      searchByname : '',
      searchBybvn : '',
      searchBynin : '',
      searchByaccount : '',
      searchBypensionId : '',
      searchBybank : '',
      searchBylga : '',
      searchByminPension : '',
      searchBymaxPension : '',
      searchBydualPensioner : false,
      searchBygradeLevel : '',
      showAdvancedFilters : false,
      // Sorting
      sortField : '',
      sortDir : 'asc',
      // Dropdown Data
      banksList : [
        { id: 1, name: 'Access Bank' },
        { id: 2, name: 'First Bank of Nigeria' },
        { id: 3, name: 'Guaranty Trust Bank' },
        { id: 4, name: 'United Bank for Africa' },
        { id: 5, name: 'Zenith Bank' },
        { id: 6, name: 'Union Bank of Nigeria' },
        { id: 7, name: 'Fidelity Bank' },
        { id: 8, name: 'Ecobank Nigeria' },
        { id: 9, name: 'Keystone Bank' },
        { id: 10, name: 'Unity Bank' },
        { id: 11, name: 'Polaris Bank' },
        { id: 12, name: 'Stanbic IBTC Bank' },
        { id: 13, name: 'Sterling Bank' },
        { id: 14, name: 'Wema Bank' },
        { id: 15, name: 'First City Monument Bank' },
      ],
      lgasList : [],
      page : '',
      message : '',
      perPage: 0,
      currentPage: 0,
      rows : 0,
      // Archive Modal
      showArchiveModal: false,
      selectedPensioner: null,
      isArchiving: false,
      archiveSuccess: false,
      archiveError: '',
    }
  },


  components: 
  {
    VsudSpinner,
    VsudNodata,
    VsudBadge,
    VsudButton,
    VsudSpinnerSmall,
  },

  created()
  {
    this.getPensioners();
    this.getLgasList();
    this.moment = moment;
  },

  methods :
  {
    /**
     * Old Methods
     * 
     * @description : Deprecated 
     */
    async GetBenficiaries(page='', name = '', phone = '', status = '')
    {  
      this.isLoading = (page || name || phone || status)?  false : true;
      this.isSearchLoading = (page || name || phone || status)? true : false;

      const nameUrl = (name!=='')? '&name='+name : '';
      const phoneUrl = (phone!=='')? '&phone_no='+phone : '';
      const statusUrl = (status!=='')? this.cleanStatus(status) : '';
      const pageUrl = (page!=='')? '&page='+page : '';
      const perPageUrl = '?perPage=100';
      const paramUrl = perPageUrl+nameUrl+phoneUrl+statusUrl+pageUrl

      console.log(paramUrl);

       try{
          const response = await AuthService.getBenficiaries(paramUrl);
          
          // # Debug
          console.log(response);

          if(response.data.length>0)
          {
            this.TableData = response.data;
            this.perPage = response.meta.pagination.perPage;
            this.currentPage = response.meta.pagination.currentPage;
            this.rows = response.meta.pagination.total;

            // # Debugger
            console.log('# [ Debugger ] - Check table data :');
            console.log(this.TableData);
          }
          else
          {
            this.message = 'No data please try again';
          }
          this.isLoading = false;
          this.isSearchLoading = false;
       }
       catch(error){
        if(error)
        { 
          this.isLoading = false;
          this.isSearchLoading = false;
          this.message  = error.message;
          console.log(error);
        }
       }
    },

    async GetStates()
    {
        this.isStateLoading = true;

        try{
            const response = await AuthService.getStates('?perPage=100');
            console.log(response);
            this.states = response.data
            this.isStateLoading = false;
        }
        catch(error){
          if(error)
          { 
            console.log(error);
          }
        }
    },

    reloadPage()
    {
      location.reload();
    },

    cleanStatus(type)
    {
        let res = null; 

        switch(type)
        {
          case "updated" : res = '&updated=true'; break;
          case "not-updated" : res = '&updated=false'; break;
          case "active" : res = '&status=active'; break;
          case "not-active" : res = '&status=inactive'; break;
        }

        return res;
    },

    renderStatus(status, updated, type='status')
    {
        let text  = 'Enumerated'; 
        let color = 'success';

        if(status=='inactive')
        {
            color = 'danger'; text = 'In-active'
        }

        if(updated===true)
        {
            text = 'Updated'; color = 'info';
        }

        return (type=='status')? text : color;
    },

    /**
     * New methods
     * 
     * @description : N/A 
     */
    checkGpsExist(data)
    {
        var gps = { status : false, is_polygon : false};

        if(data.lat!==null&&data.lng!==null)
        {
            gps.status = true;

            // # [ Debugger ]
            // console.log(data.latitude.length);
            // console.log(data.longitude.length);

            // : # Deprecated 
            // if(data.latitude.length>str_limit||data.longitude.length>str_limit)
            // {
            //     gps.is_polygon = true;
            // }
            // let str_limit = 20;
            // console.log(gps);
        }
       
        return gps;
    },

    async getPensioners()
    {
      this.loader.table = true;
      this.message = '';

      // Build query parameters
      const params = new URLSearchParams();
      params.append('perPage', '100');
      
      // Basic filters
      if (this.searchByname) params.append('name', this.searchByname);
      if (this.searchByphone) params.append('phone_no', this.searchByphone);
      if (this.searchBybvn) params.append('bvn', this.searchBybvn);
      if (this.searchBynin) params.append('nin', this.searchBynin);
      if (this.searchByaccount) params.append('account_number', this.searchByaccount);
      if (this.searchBypensionId) params.append('pension_id', this.searchBypensionId);
      if (this.searchBystatus) params.append('status', this.searchBystatus);
      if (this.searchBysubStatus) params.append('sub_status', this.searchBysubStatus);
      if (this.searchBytype) params.append('is_lga', this.searchBytype);
      if (this.page) params.append('page', this.page);
      
      // Advanced filters (param names must match backend PensionerFilters classes)
      if (this.searchBybank) params.append('bank', this.searchBybank);
      if (this.searchBylga) params.append('lga', this.searchBylga);
      if (this.searchByminPension) params.append('min_amount', this.searchByminPension);
      if (this.searchBymaxPension) params.append('max_amount', this.searchBymaxPension);
      if (this.searchBydualPensioner) params.append('dual_pensioner', 'true');
      if (this.searchBygradeLevel) params.append('grade_level', this.searchBygradeLevel);

      // Sorting (e.g. sort=monthly_pension&dir=asc|desc)
      if (this.sortField) {
        params.append('sort', this.sortField);
        params.append('dir', this.sortDir);
      }

      const paramUrl = '?' + params.toString();

       try{
          const response = await AuthService.getPensioners(paramUrl);

          if(response.data.length>0)
          {
            this.TableData = response.data;
            this.perPage = response.meta.pagination.perPage;
            this.currentPage = response.meta.pagination.currentPage;
            this.rows = response.meta.pagination.total;
          }
          else
          {
            this.message = 'No records found matching your search criteria';
          }
          this.isLoading = false;
       }
       catch(error)
       {
          this.message = error.message;
          console.log(error);
       }finally{
          this.loader.table = false;
       }
    },

    async getLgasList()
    {
      try {
        const response = await AuthService.getLgas('?perPage=50');
        if(response.data && response.data.length > 0) {
          this.lgasList = response.data;
        }
      } catch(error) {
        console.log('Error loading LGAs:', error);
      }
    },

    toggleAdvancedFilters()
    {
      this.showAdvancedFilters = !this.showAdvancedFilters;
    },

    toggleSort(field)
    {
      if (this.sortField === field) {
        // Same column: flip direction
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        // New column: default to descending (highest first)
        this.sortField = field;
        this.sortDir = 'desc';
      }
      this.page = ''; // Back to first page so the extreme row is on top
      this.getPensioners();
    },

    sortIconClass(field)
    {
      if (this.sortField !== field) return 'fa-sort text-muted';
      return this.sortDir === 'asc' ? 'fa-sort-up text-info' : 'fa-sort-down text-info';
    },

    handlePageChange(value) 
    {
      this.page = value;
      this.getPensioners();
    },

    SubmitSearchForm()
    {
      this.page = ''; // Reset to first page on new search
      this.getPensioners();
    },

    SearchReset()
    {
      // Reset all search filters
      this.searchByname = '';
      this.searchByphone = '';
      this.searchBybvn = '';
      this.searchBynin = '';
      this.searchByaccount = '';
      this.searchBypensionId = '';
      this.searchBystatus = '';
      this.searchBysubStatus = '';
      this.searchBytype = '';
      this.searchBybank = '';
      this.searchBylga = '';
      this.searchByminPension = '';
      this.searchBymaxPension = '';
      this.searchBydualPensioner = false;
      this.searchBygradeLevel = '';
      this.sortField = '';
      this.sortDir = 'asc';
      this.page = '';
      
      this.getPensioners();
    },

    getUserLoggedIn()
    {
        return Helper.UserClass();
    },

    truncateText(text, maxLength)
    {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },

    getPensionId(data)
    {
      // Handle different field name variations from API
      return data.pensionId || data.uniquePensionerId || data.unique_pensioner_id || null;
    },

    getSubStatusColor(subStatus)
    {
      const colors = {
        'valid': 'success',
        'incomplete': 'warning',
        'discrepancy': 'danger',
        'suspicious': 'dark',
        'not_on_payroll': 'secondary'
      };
      return colors[subStatus] || 'secondary';
    },

    formatSubStatus(subStatus)
    {
      const labels = {
        'valid': 'Valid',
        'incomplete': 'Incomplete',
        'discrepancy': 'Discrepancy',
        'suspicious': 'Suspicious',
        'not_on_payroll': 'Not on Payroll'
      };
      return labels[subStatus] || 'Pending';
    },

    // Archive Modal Methods
    openArchiveModal(pensioner) {
      this.selectedPensioner = pensioner;
      this.archiveError = '';
      this.archiveSuccess = false;
      this.isArchiving = false;
      this.showArchiveModal = true;
    },

    closeArchiveModal() {
      if (this.isArchiving) return; // Prevent closing while archiving
      
      this.showArchiveModal = false;
      this.selectedPensioner = null;
      this.archiveError = '';
      this.archiveSuccess = false;
      
      // If archive was successful, refresh the list
      if (this.archiveSuccess) {
        this.getPensioners();
      }
    },

    async archivePensioner() {
      if (!this.selectedPensioner) return;

      this.isArchiving = true;
      this.archiveError = '';

      try {
        const uuid = this.selectedPensioner.id || this.selectedPensioner.uuid;
        await AuthService.archivePensioner(uuid);
        
        this.archiveSuccess = true;
        
        // Remove from local table data immediately
        this.TableData = this.TableData.filter(p => p.id !== this.selectedPensioner.id);
        
        // Auto-close after 2 seconds
        setTimeout(() => {
          this.closeArchiveModal();
        }, 2000);

      } catch (error) {
        console.error('Error archiving pensioner:', error);
        this.archiveError = error.response?.data?.message || error.message || 'Failed to archive pensioner. Please try again.';
        AuthService.CheckResponseError(error);
      } finally {
        this.isArchiving = false;
      }
    }
  }
};
</script>

<style scoped>
.filter-records-holder {
  background: linear-gradient(to right, #f8f9fa, #fff);
  border-bottom: 1px solid #e9ecef;
}

.filter-records-holder .form-control-sm {
  font-size: 0.75rem;
  padding: 0.35rem 0.65rem;
}

.filter-records-holder .form-label {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.bg-gray-100 {
  background-color: #f8f9fa !important;
}

.gap-2 {
  gap: 0.5rem;
}

.table td {
  vertical-align: middle;
  white-space: nowrap;
}

.table th {
  white-space: nowrap;
  font-size: 0.65rem;
}

.sortable-th {
  cursor: pointer;
  user-select: none;
}

.sortable-th:hover {
  color: #17c1e8 !important;
}

.btn-link {
  padding: 0.25rem 0.5rem;
}

.text-muted {
  color: #adb5bd !important;
}
</style>

<!-- Global styles for Teleported modal -->
<style>
/* Archive Modal styles - must be global because Teleport renders outside component scope */
.modal.show.d-block {
    z-index: 10050 !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background-color: transparent !important;
}

.modal-backdrop.fade.show {
    z-index: 10040 !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
}

.modal.show.d-block .modal-dialog {
    position: relative;
    z-index: 10051;
}

.modal.show.d-block .modal-content {
    background-color: #fff;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
</style>
